import { createVNode as l, mergeProps as o } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/TemplateFilledStandard.js";
import m from "../components/PfIcon.js";
const e = (t, r) => {
  const a = {
    ...t,
    ...r.attrs
  };
  return l(m, o(a, {
    icon: d
  }), null);
};
e.displayName = "TemplateFilledStandard";
e.inheritAttrs = !1;
export {
  e as default
};
